// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"adfcb288","942":"bfbb321e"}[chunkId] + ".chunk.js";
};